import logoTk from "@/assets/logo-tk.png";

interface SplashScreenProps {
  /** Optional message under the logo. */
  message?: string;
}

/**
 * Full-screen splash with the TK logo pulsing inside a soft gold glow halo.
 * Used as the global lazy-route fallback and while auth/permissions resolve.
 */
export function SplashScreen({ message }: SplashScreenProps) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background overflow-hidden">
      {/* Ambient radial glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 45%, hsl(var(--primary) / 0.18) 0%, transparent 55%)",
        }}
      />

      <div className="relative flex flex-col items-center gap-8">
        {/* Pulsing halo behind the logo */}
        <div className="relative flex items-center justify-center">
          <span
            aria-hidden
            className="absolute inline-block h-40 w-40 rounded-full splash-halo"
          />
          <span
            aria-hidden
            className="absolute inline-block h-40 w-40 rounded-full splash-halo"
            style={{ animationDelay: "0.9s" }}
          />
          <div className="relative flex h-28 w-28 items-center justify-center splash-logo-float">
            <img
              src={logoTk}
              alt="TK Estética Avançada"
              className="h-full w-full object-contain drop-shadow-[0_8px_24px_hsl(var(--primary)/0.45)]"
              draggable={false}
            />
          </div>
        </div>

        {/* Wordmark + tagline */}
        <div className="flex flex-col items-center gap-2 text-center">
          <span className="font-display text-xl tracking-[0.32em] text-gradient-gold uppercase">
            TK Estética
          </span>
          <span className="text-[11px] uppercase tracking-[0.4em] text-muted-foreground">
            {message ?? "Preparando sua experiência"}
          </span>
        </div>

        {/* Shimmer progress bar */}
        <div className="relative h-[3px] w-44 overflow-hidden rounded-full bg-muted/60">
          <span className="absolute inset-y-0 left-0 w-1/3 rounded-full bg-gradient-gold splash-shimmer" />
        </div>
      </div>
    </div>
  );
}
